import { render } from "./SerialStart.vue?vue&type=template&id=04809da7"
import script from "./SerialStart.vue?vue&type=script&lang=js"
export * from "./SerialStart.vue?vue&type=script&lang=js"
script.render = render

export default script